<template>
  <div class="row settings--section">
    <div class="medium-4 small-12 title--section">
      <p class="sub-block-title">
        {{ title }}
      </p>
      <p class="sub-head">
        {{ subTitle }}
      </p>
      <!-- show phone number  -->
      <div v-if="showPhoneNumber">
          <p class="sub-block-title">{{$t('SETTINGS.INBOXES.SETTINGS.PHONE_SECTION.LABEL')}}</p>
        <p class="sub-head">{{ whatsapp_PhoneNumber }}</p>
      </div>
      <CommunalRestrictCard v-if="isCommunalInbox"  :inbox="inbox"/>
        <!-- v-if="inbox.whatsapp_personal && inbox.status === 'disconnected'" -->
      <ReConnectWhatsappPersonal
        v-if="inbox.whatsapp_personal && (!wa_status.connected || !wa_status.active)"
        :inboxName="inbox.name"
        @onCreateChannel="onReconnectInbox"
      />
    </div>
    <div class="medium-6 small-12">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import CommunalRestrictCard from "../routes/dashboard/settings/inbox/CommunalRestrictCard.vue";
import  ReConnectWhatsappPersonal from 'dashboard/routes\/dashboard/settings/inbox/ReConnectWhatsappPersonal.vue';
import InboxesAPI from "dashboard/api/inboxes.js";

export default {
  components:{
    CommunalRestrictCard,
    ReConnectWhatsappPersonal,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    isCommunalInbox: {
      type: Boolean,
      required: false,
    },
    inbox:{
      type: Object,
      default: {},
      required: false,
    },
    showPhoneNumber:{
      type:Boolean,
      default: false
    },
  },
  data(){
    return {
      wa_status: {},
    }
  },
  computed:{
    whatsapp_PhoneNumber(){
      return this.inbox.phone_number;
    },
  },
  watch: {
    "inbox.id": {
      immediate: true, // ✅ run on component mount too
      handler(newVal) {
        if (newVal) {
          this.checkWaPresonalStatus();
        }
      },
    },
  },
  methods:{
    onReconnectInbox(newInbox){
      window.location.reload();
    },
    async checkWaPresonalStatus(){
      try {
        this.wa_status = {};
        // watch the inbox.id, for personal whatsapp, call to know the status and render ReconnectQR if active:false
        const {data} = await InboxesAPI.fetch_ws_personal_status({
          name: this.inbox.name,
        });
        console.log(data,"wa status");
        this.wa_status = data;

      } catch (error) {
        console.log(error);
        this.wa_status = {};
      }
    },
  },
};
</script>

<style lang="scss">
@import '~dashboard/assets/scss/variables';

.settings--section {
  border-bottom: 1px solid $color-border;
  display: flex;
  padding: $space-normal $space-normal $space-normal 0;

  .sub-block-title {
    color: $color-woot;
    font-weight: $font-weight-medium;
    margin-bottom: 0;
  }

  .title--section {
    padding-right: var(--space-large);
  }
}
</style>
